import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListModule } from 'src/@fury/shared/list/list.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMaskModule } from 'ngx-mask';
import { CKEditorModule } from 'ng2-ckeditor';
import {  MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { EmailTemplatesRoutingModule } from './email-templates-routing.module';
import { ViewEmailTemplateComponent } from './view-email-template/view-email-template.component';
import { EmailTemplatesComponent } from './email-templates.component';
import { EditEmailTemplateComponent } from './edit-email-template/edit-email-template.component';


@NgModule({
  declarations: [
    EmailTemplatesComponent,
    ViewEmailTemplateComponent,
    EditEmailTemplateComponent,
  ],
  imports: [
    CommonModule,
    EmailTemplatesRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatCheckboxModule,
    MatTableModule,
    FlexLayoutModule,
    MatIconModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MatSelectModule,
    MatOptionModule,
    NgxMaskModule,
    CKEditorModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class EmailTemplatesModule { }
